import { complexities } from "../../utils/complexity";

export const templateData = [
  {
    _id: "12345678",
    title: "Sample Template",
    subject: "Math",
    status: "Published",
    publishedAt: "2025-06-10",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Algebra",
        description: "Basic algebraic concepts and operations.",
        complexities: ["easy"],
        noOfQs: 5,
      },
      {
        _id: "subtopic2",
        title: "Geometry",
        description:
          "Understanding shapes, sizes, and the properties of space.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "Calculus",
        description: "Introduction to limits, derivatives, and integrals.",
        complexities: ["hard"],
        noOfQs: 2,
      },
      {
        _id: "subtopic4",
        title: "Statistics",
        description: "Data analysis, probability, and statistical inference.",
        complexities: ["easy", "medium"],
        noOfQs: 4,
      },
      {
        _id: "subtopic5",
        title: "Trigonometry",
        description: "Study of triangles, angles, and their relationships.",
        complexities: ["medium"],
        noOfQs: 3,
      },
      {
        _id: "subtopic6",
        title: "Number Theory",
        description:
          "Properties and relationships of numbers, especially integers.",
        complexities: ["hard"],
        noOfQs: 2,
      },
      {
        _id: "subtopic7",
        title: "Linear Algebra",
        description:
          "Study of vectors, vector spaces, and linear transformations.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
    ],
  },
  {
    _id: "87654321",
    title: "Sample Template 2",
    subject: "Science",
    status: "Draft",
    publishedAt: "2025-07-15",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Physics",
        description: "Fundamental principles of matter and energy.",
        complexities: ["easy", "medium", "hard"],
        noOfQs: 4,
      },
      {
        _id: "subtopic2",
        title: "Chemistry",
        description: "Study of substances, their properties, and reactions.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "Biology",
        description: "Life sciences covering organisms and ecosystems.",
        complexities: ["easy", "medium"],
        noOfQs: 5,
      },
    ],
  },
  {
    _id: "11223344",
    title: "Sample Template 3",
    subject: "History",
    status: "Published",
    publishedAt: "2025-08-20",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Ancient Civilizations",
        description: "Study of early human societies and cultures.",
        complexities: ["easy", "medium"],
        noOfQs: 4,
      },
      {
        _id: "subtopic2",
        title: "Modern History",
        description: "Events and developments from the 18th century onwards.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "World Wars",
        description: "Analysis of the causes and impacts of the World Wars.",
        complexities: ["hard"],
        noOfQs: 2,
      },
    ],
  },
  {
    _id: "44332211",
    title: "Sample Template 4",
    subject: "Geography",
    status: "Draft",
    publishedAt: "2025-09-25",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Physical Geography",
        description: "Study of natural features and processes of the Earth.",
        complexities: ["easy", "medium"],
        noOfQs: 5,
      },
      {
        _id: "subtopic2",
        title: "Human Geography",
        description:
          "Exploration of human societies and their spatial relationships.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "Environmental Geography",
        description: "Interaction between humans and the environment.",
        complexities: ["hard"],
        noOfQs: 2,
      },
    ],
  },
  {
    _id: "99887766",
    title: "Sample Template 5",
    subject: "English",
    status: "Published",
    publishedAt: "2025-10-30",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Literature",
        description: "Study of literary works and their analysis.",
        complexities: ["easy", "medium"],
        noOfQs: 4,
      },
      {
        _id: "subtopic2",
        title: "Grammar",
        description: "Rules and structure of the English language.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "Composition",
        description:
          "Writing skills and techniques for effective communication.",
        complexities: ["hard"],
        noOfQs: 2,
      },
    ],
  },
  {
    _id: "66554433",
    title: "Sample Template 6",
    subject: "Physics",
    status: "Draft",
    publishedAt: "2025-11-05",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Classical Mechanics",
        description: "Laws of motion and forces acting on objects.",
        complexities: ["easy", "medium"],
        noOfQs: 5,
      },
      {
        _id: "subtopic2",
        title: "Thermodynamics",
        description: "Study of heat, energy, and their transformations.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "Electromagnetism",
        description: "Electricity, magnetism, and their interrelations.",
        complexities: ["hard"],
        noOfQs: 2,
      },
    ],
  },
  {
    _id: "33221100",
    title: "Sample Template 7",
    subject: "Chemistry",
    status: "Published",
    publishedAt: "2025-12-15",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Organic Chemistry",
        description:
          "Study of carbon-containing compounds and their reactions.",
        complexities: ["easy", "medium"],
        noOfQs: 4,
      },
      {
        _id: "subtopic2",
        title: "Inorganic Chemistry",
        description: "Study of inorganic compounds and materials.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "Physical Chemistry",
        description: "Application of physical principles to chemical systems.",
        complexities: ["hard"],
        noOfQs: 2,
      },
    ],
  },
  {
    _id: "00112233",
    title: "Sample Template 8",
    subject: "Biology",
    status: "Draft",
    publishedAt: "2026-01-20",
    image: "exam-template.png",
    subtopic: [
      {
        _id: "subtopic1",
        title: "Cell Biology",
        description: "Study of cell structure, function, and processes.",
        complexities: ["easy", "medium"],
        noOfQs: 5,
      },
      {
        _id: "subtopic2",
        title: "Genetics",
        description: "Understanding heredity, genes, and genetic variation.",
        complexities: ["medium", "hard"],
        noOfQs: 3,
      },
      {
        _id: "subtopic3",
        title: "Ecology",
        description: "Interactions between organisms and their environment.",
        complexities: ["hard"],
        noOfQs: 2,
      },
    ],
  },
];
export const status = ["Published", "Draft"];
export const subjects = [
  {
    id: "1",
    name: "Mathematics",
  },
  {
    id: "2",
    name: "Science",
  },
  {
    id: "3",
    name: "History",
  },
  {
    id: "4",
    name: "Geography",
  },
  {
    id: "5",
    name: "English",
  },
  {
    id: "6",
    name: "Physics",
  },
  {
    id: "7",
    name: "Chemistry",
  },
  {
    id: "8",
    name: "Biology",
  },
];
export const publishedAt = [
  "2025-06-10",
  "2025-07-15",
  "2025-08-20",
  "2025-09-25",
];
